import type FieldId from "../fields/FieldId";
import type { FormScope, FormVersion } from "../state/formVersion";
import { useFormVersionDispatch } from "../state/formVersion";
import type { SetStoreFunction } from "solid-js/store";
import { initialized } from "../utils/initializedUtil";
import { isNil } from "lodash-es";
import { Scope } from "../types";
import type { GoogleSheetsIntegrationConfiguration } from "../integrations/definitions/GoogleSheetsIntegration";
import type { EmailIntegrationConfiguration } from "../integrations/definitions/EmailIntegration";

let setFormVersionStore: SetStoreFunction<FormVersion> | null = null;

const init = () => {
  setFormVersionStore = useFormVersionDispatch();
};

const getSetFormVersionStore = () => initialized(setFormVersionStore, "setFormVersionStore");

export default {
  init,
  // This code has been extracted from 'IntegrationService' solely because of circular dependency issues with vitest
  removeEmailAttachments: (fieldId: FieldId, scope: FormScope) => {
    if (scope === Scope.ROOT) {
      getSetFormVersionStore()(
        "integrations",
        (integration) => integration.type === "mail",
        "configuration",
        "pinFieldsToAttach",
        (value: EmailIntegrationConfiguration["pinFieldsToAttach"]) => value.filter((id) => !id.equals(fieldId)),
      );
    } else {
      getSetFormVersionStore()(
        "subforms",
        (subform) => subform.uid.equals(scope) && !isNil(subform.emailConfiguration),
        "emailConfiguration",
        "pinFieldsToAttach",
        (value) => value.filter((id) => !id.equals(fieldId)),
      );
    }
  },
  removeGoogleSheetColumnOrder: (fieldId: FieldId) => {
    getSetFormVersionStore()(
      "integrations",
      (integration) => integration.type === "googlesheets",
      "configuration",
      "columnOrder",
      (value: GoogleSheetsIntegrationConfiguration["columnOrder"]) =>
        value?.filter(({ type, value }) => !(type === "field" && value.id.equals(fieldId))),
    );
  },
};
